// Pegá acá el mismo Client ID que configures en el backend (appsettings.json).
// Lo obtenés en Google Cloud Console → APIs y servicios → Credenciales →
// Crear ID de cliente de OAuth → Aplicación web.
export const GOOGLE_CLIENT_ID = "906298487978-cplc6krtcrngvc3noi5u2hfcsijea3ro.apps.googleusercontent.com";
